import { useState } from 'react'
import { entries, startCase } from 'lodash'
import { legacyRoleRank } from 'app/types/roles'
import { notifyError, notifySuccess } from 'app/services/notify.client'
import { useUser } from 'app/utils'
import { useUserStore } from 'app/stores/StoreContext'
import { bg } from 'lib/background'
import { debug, logError } from 'lib/logging'

export type ProfileUser = {
  id?: string
  name?: string
  email?: string
  role?: number
  type?: string
  workspaceId?: string
  orgId?: string
}

export type UseProfileReturn = {
  user: ProfileUser | undefined
  saving: boolean
  roleName: string
  onSubmit: (data: { name: string; email: string }) => void
}

export function useProfile(): UseProfileReturn {
  const user = useUser()
  const userStore = useUserStore()
  const [saving, setSaving] = useState(false)

  const roleName = startCase(entries(legacyRoleRank).find(([, num]) => user?.role === num)?.[0]) || ``

  const onSubmit = (formData: { name: string; email: string }) => {
    debug(`profile`, `submit`, formData)
    setSaving(true)
    bg(async () => {
      try {
        const result = await userStore.update(user!.id!, formData)
        if (result.error) throw result.error
        notifySuccess(`Save successful`)
        setSaving(false)
      } catch (err: unknown) {
        logError(`error saving profile`, err)
        notifyError((err as Error)?.message || `Error saving`)
        setSaving(false)
      }
    })
  }

  return {
    user,
    saving,
    roleName,
    onSubmit,
  }
}
